// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Loading_loadingWrapper_2i-Rg .ant-spin-dot{font-size:1rem}", ""]);
// Exports
exports.locals = {
	"loadingWrapper": "Loading_loadingWrapper_2i-Rg"
};
module.exports = exports;
